import { SOCKET_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TEqualityFunction, TSocketSelector } from '../types';

export const useSocketSelector = <TSelected>(selector: TSocketSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
    return useCustomSelector<TSelected, typeof SOCKET_REDUCER>(SOCKET_REDUCER, selector, equalityFn);
};
